import { render, staticRenderFns } from "./borrow.vue?vue&type=template&id=9256cf5c&"
import script from "./borrow.vue?vue&type=script&lang=js&"
export * from "./borrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports